
var HistoryManager = (function () {
  var COPYRIGHT = "(c) Copyright The Australian e-Health Research Centre, CSIRO, 2019",
      debug,
      parameters = [
        'view', 'system', 'concept', 'version',
        // 'versionURI',
        'valueset', 'search', 'fhir', 'tour',
      ],
      defaults = {
        fhir: 'https://r4.ontoserver.csiro.au/fhir',
        system: 'http://snomed.info/sct',
        view: 'cs',
      },
      title,
      state = {},
      listeners = [];

  return {
    settings: {
    },

    init: function (flag, initCb) {
      var s = this.settings,
          self = this;

      debug = function() {
        if (flag) console.log.apply(this, arguments);
      }
      debug('HistoryManager.init', flag);

      const launchParams = localStorage.getItem('SHRIMP_LAUNCH');
      if (launchParams) {
        state = parseQueryString(launchParams);
        localStorage.removeItem('SHRIMP_LAUNCH');
      } else {
        state = parseQueryString(window.location.search);
      }

      if (window.history) {
        window.addEventListener("popstate", function(e) {
          if (e.state) {
            state = e.state;
            notify(state);
          }
        });
      }

      // ready for use, so make methods available

      self.get = function (key) {
        return state[key];
      };

      self.pushState = function() {
        window.history.pushState(state, title, toQueryString(state));
      };

      self.userAction = function(cb) {
        return function () {
          var result = cb.apply(this, arguments);
          self.pushState();
          return result;
        };
      };

      self.track = function(ctxt) {
        parameters.forEach(function (key) {
          if (typeof ctxt[key] !== 'undefined') {
            state[key] = ctxt[key];
          } else if (ctxt[key] === '' || ctxt[key] === []) {
            state[key] = undefined;
          }
        });

        title = 'Shrimp/&#x1f525;';
        if (ctxt.title) {
          title = title + ' : ' + ctxt.title;
        }

      };

      if (initCb) {
        initCb(state);
      }

      // enable this last of all
      self.refresh = function() {
        window.history.replaceState(state, title, toQueryString(state))
        notify(state);
      };

    },

    addListener: function (listener) { listeners.push(listener); },

  };

  function notify(state) {
    debug('HistoryManager.notify', state);
    listeners.forEach(function (cb) {
      try {
        cb(state);
      } catch (err) {
        console.log(err);
      }
    });
  }

  function toQueryString(s) {
    var fields = [];
    parameters.forEach(function (key) {
      var val = s[key];
      if (val && val !== defaults[key]) {
        if (Array.isArray(val)) {
          val.forEach(function (v) {
            fields.push(key + '=' + encodeURIComponent(v));
          });
        } else {
          fields.push(key + '=' + encodeURIComponent(val));
        }
      }
    });
    return '?'+fields.join('&');
  }

  function parseQueryString( queryString ) {
    var params = {}, queries;

    // Split into key/value pairs
    queries = queryString.replace(/^\?/,"").replace(/#.$/,"").split("&");

    // Convert the array of strings into an object
    queries.forEach(function (query) {
      var temp = query.split('='),
          key = decodeURIComponent(temp[0]),
          val = decodeURIComponent(temp[1]);
      if ('iss' === key) key = 'fhir';
      if (typeof params[key] === "undefined") {	// ==0
        params[key] = val;
      } else if (Array.isArray(params[key])) {	// >1
        params[key].push(val);
      } else if (params[key] !== val) {
        params[key] = [params[key], val];	// ==1
      }
    });

    if (params.help) params.tour = true;

    parameters.forEach(function (key) {
      if (!params[key] && defaults[key]) {
        params[key] = defaults[key];
      }
    });

    return params;
  };

}());

